import { Lock } from "@material-ui/icons";
import { Button, Input } from "antd";
import styled from "styled-components";

export const Wrapper = styled.div`
  min-height: 150px;
`;

export const RadioGroupWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  .ant-select {
    min-width: 140px;
  }
  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    padding: 0 8px;
    border-color: var(--vape);
    border-radius: var(--border-radius);
  }
  .ant-select-arrow {
    right: 8px;
    color: var(--flint);
  }
  .ant-radio-button-wrapper {
    font-size: 11px;
  }
`;

export const BinSettingsContent = styled.div`
  background: var(--bin-section-bg, #ffffff);
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 16px;
  overflow-y: overlay;
  height: 100%;
`;

// Not a scroll container: as one, the flex parent could shrink it below its
// rows and it would show its own scrollbar. The parent already scrolls.
export const BinSettingsContentGrid = styled(BinSettingsContent)`
  background: var(--bin-section-bg, #ffffff);
  display: grid;
  grid-template-columns: ${({ columnCount }) => `repeat(${columnCount}, 1fr)`};
  gap: 6px 9px;
  padding: 0;
  overflow: visible;
`;

export const BinInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  ant-select-selector {
    height: 30px;
  }
`;

export const BinOptionsRow = styled.div`
  display: flex;
  flex-direction: row;
  grid-column: 1 / span 4;
  gap: 12px;
  justify-content: flex-start;
  align-items: center;
  .ant-checkbox-wrapper {
    font-size: 0.9em;
    align-items: center;
    .ant-checkbox {
      top: 0;
    }
  }
`;

export const BinInputLabel = styled.span`
  font-size: 1.2rem;
`;

export const BinUpdateButton = styled(Button)`
  --ant-primary-color-hover: var(--color-primary-hover);
  grid-column: 1 / span 4;
  border-radius: 4px;
  font-weight: 500;
`;

export const StyledInput = styled(Input)`
  height: 30px;
  border-radius: var(--border-radius);
`;

// Scoped to this row so the bin size grid keeps its own inputs.
export const MaxBinsGrid = styled(BinSettingsContentGrid)`
  grid-template-columns: minmax(0, 0.8fr) minmax(0, 0.6fr) minmax(0, 1.6fr);
  gap: 8px;

  ${BinInputWrapper} {
    gap: 4px;
    min-width: 0;
  }

  ${StyledInput} {
    padding: 0 8px;
    border: 1px solid var(--vape);
    border-radius: 2px;
    color: var(--color-text);

    &:focus {
      border-color: var(--color-primary);
      box-shadow: var(--shadow-focus);
    }
  }
`;

export const BinResetButton = styled(Button)`
  justify-self: flex-end;
  grid-column: 1 / span 4;
  height: 2rem;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #a2aaad;
  font-size: 1.2rem;
  font-weight: var(--fontWeightRegular);
  padding-left: 0;
  padding-right: 0;

  &:hover {
    color: var(--color-primary);
  }
`;

export const BinHeaderActions = styled.div`
  display: flex;
  flex: none;
  align-items: center;
  gap: 4px;
  margin-left: auto;
`;

export const BinIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: var(--border-radius);
  background: transparent;
  color: var(--flint);
  cursor: pointer;
  transition: background var(--duration-short) var(--ease);

  &:hover {
    background: var(--mist);
    color: var(--color-primary);
  }

  &[aria-checked="true"] {
    background: var(--color-primary);
    color: var(--color-white);
  }

  &[aria-checked="true"]:hover {
    background: var(--color-primary-hover);
  }

  &:disabled {
    background: transparent;
    color: var(--flint);
    cursor: not-allowed;
  }
`;

export const BinLockButton = styled(Button)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  height: 100%;
  outline: none;
  color: #a2aaad;
  &:hover {
    color: var(--color-primary);
  }
`;

export const LockMessageWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const LockIconWrapper = styled(Lock)`
  color: var(--color-primary);
`;

export const WarningContainer = styled.div`
  padding-top: 8px;
  color: var(--color-danger);
  font-weight: var(--fontWeightMedium);
  text-align: left;
`;
